import { UseCaseInteractor } from '../../../kernel/use-case'
import { RoleRepository } from '../domain/role.repository'

export const assignRolePermissionsUseCase: UseCaseInteractor<
  [roleRepository: RoleRepository],
  [roleId: string, permissions: string[]],
  boolean
> =
  (roleRepository: RoleRepository) =>
  async (roleId: string, permissions: string[]): Promise<boolean> => {
    return roleRepository.assignRolePermissions(roleId, permissions)
  }
